import React from 'react';
import PropTypes from 'prop-types';
import BasicPageOptionButton from 'components/admin/basic/BasicPageOptionButton';
import BackEventButton from 'components/admin/result/BackEventButton';

const AgeResultPageOptionButton = ({ meet, clubId, centerTitle, viewType }) => {
  return (
    <BasicPageOptionButton
      centerTitle={centerTitle}
      buttonChild={<BackEventButton meet={meet} clubId={clubId} viewType={viewType} />}
    />
  );
};

AgeResultPageOptionButton.propTypes = {
  meet: PropTypes.object,
  clubId: PropTypes.string,
  resultType: PropTypes.string,
  centerTitle: PropTypes.string,
  viewType: PropTypes.string,
};

export default AgeResultPageOptionButton;
